import { render, staticRenderFns } from "./proDownList.vue?vue&type=template&id=5fade0e0&"
import script from "./proDownList.vue?vue&type=script&lang=js&"
export * from "./proDownList.vue?vue&type=script&lang=js&"
import style0 from "./proDownList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports